import { NotificationBell } from '@/components/NotificationBell';
import { PageTransition } from '@/components/PageTransition';
import { EnvironmentBadge } from '@/components/ui/environment-badge';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { ReactNode } from 'react';

interface MainLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
}

export function MainLayout({ children, title, subtitle }: MainLayoutProps) {
  return (
    <>
      <header className="sticky top-0 z-10 flex h-16 shrink-0 items-center gap-2 border-b bg-background px-4">
        <SidebarTrigger className="-ml-1" />
        <div className="flex items-center justify-between flex-1">
          <div>
            <h1 className="text-2xl font-bold text-foreground">{title}</h1>
            {subtitle && (
              <p className="text-sm text-muted-foreground">{subtitle}</p>
            )}
          </div>
          <div className="flex items-center gap-4">
            <EnvironmentBadge />
            <NotificationBell />
          </div>
        </div>
      </header>

      <main className="flex-1 p-6">
        <PageTransition>
          {children}
        </PageTransition>
      </main>
    </>
  );
}
